/* import __COLOCATED_TEMPLATE__ from './buyer-profile.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { Promise } from 'rsvp';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-buyer-profile';

export default Component.extend({
  media: service(),
  session: service(),
  currentUser: readOnly('session.currentUser'),

  /** HTML Component properties */
  tagName: 'div',
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {User} user The user whose profile will be displayed. */
  user: null,

  /** @param {Function} onSetProfileRef The function to set a reference to this component. */
  onSetProfileRef: () => {},

  /** @inheritDoc */
  didInsertElement() {
    this._super(...arguments);

    this.get('onSetProfileRef')(this);
  },

  /** @inheritDoc */
  willDestroy() {
    this._super(...arguments);

    this.get('onSetProfileRef')(null);
  },

  /** @type {Boolean} Currently there's nothing that should prevent transitioning. */
  canTransitionAway: true,

  /** Performs any final checks or tasks before the component is destroyed. */
  cleanup() {
    // No checks or tasks to perform.
    return Promise.resolve();
  },

  /** @type {Boolean} Whether the current user can edit the profile */
  _canEdit: computed('currentUser.id', 'user.id', function () {
    return this.get('currentUser.id') === this.get('user.id');
  }),

  /** @type {Boolean} Whether the current user can see this user's phone number. */
  _canSeePhoneNumber: computed(
    'currentUser.company.id',
    'currentUser.isAdmin',
    'user.company.id',
    function () {
      return this.get('currentUser.isAdmin') ||
        (this.get('currentUser.company.id') === this.get('user.company.id'));
    },
  ),

  /** @type {String} The bio (description) which is formatted for display. */
  _formattedDescription: computed('user.description', function () {
    const description = this.user.description;

    return description
      ? description
      : 'No bio provided';
  }),

  /** @type {String} All interests in comma separated string. */
  _interestsString: computed('user.tags.@each.name', function () {
    return this.get('user.tags')
      .map((tag) => tag.get('name'))
      .join(' • ');
  }),
});
